import styled from 'styled-components'

export const ModalWrapper = styled.div`
  padding: 1rem;
`

export const ModalHeader = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #191919;
`

export const ModalSubtitle = styled.p`
  font-size: 0.875rem;
  color: #666;
  margin: 0 0 1.5rem 0;
`

export const InputLabel = styled.label`
  display: block;
  font-weight: 600;
  margin-bottom: 5px;
  color: rgb(99, 115, 129);
`

export const Input = styled.input`
  width: 100%;
  padding: 0.555em 1em;
  border: 1px solid ${({ theme }) => theme.input.default.borderColor};
  border-radius: 0.28571429rem;
  font-size: 0.938rem;
  line-height: normal;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.color.primary};
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
`

export const AlertBox = styled.div<{
  $variant: 'warning' | 'info' | 'success'
}>`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
  font-size: 0.875rem;

  ${({ $variant }) => {
    switch ($variant) {
      case 'warning':
        return `
          background-color: #FEF3CD;
          border: 1px solid #FFEEBA;
          color: #856404;
        `
      case 'info':
        return `
          background-color: #D1ECF1;
          border: 1px solid #BEE5EB;
          color: #0C5460;
        `
      case 'success':
        return `
          background-color: #D4EDDA;
          border: 1px solid #C3E6CB;
          color: #155724;
        `
    }
  }}
`

export const AlertIcon = styled.span`
  flex-shrink: 0;
`

export const AlertContent = styled.span`
  a {
    color: inherit;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
  }
`

export const FormRow = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
`

export const FormField = styled.div<{ $flex?: number }>`
  flex: ${({ $flex }) => $flex || 1};
`

export const Textarea = styled.textarea`
  width: 100%;
  padding: 0.555em 1em;
  border: 1px solid ${({ theme }) => theme.input.default.borderColor};
  border-radius: 0.28571429rem;
  font-size: 0.938rem;
  line-height: 1.4;
  box-sizing: border-box;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.color.primary};
  }
`
